import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import {
  authRoutes,
  catchAllRoute,
  crewAppChildRoutes
} from './app.routes.shared';
import { excludedAdminRoutes, excludedCrewRoutes } from './app.routes.excluded';

export const routes: Routes = [
  ...authRoutes,

  {
    path: ':tenantId/app',
    loadComponent: () =>
      import('./shared/components/web-app-layout/web-app-layout.component').then(m => m.WebAppLayoutComponent),
    canActivate: [authGuard],
    children: [...crewAppChildRoutes, ...excludedCrewRoutes]
  },

  ...excludedAdminRoutes,

  ...catchAllRoute
];
